import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Matías R.',
    info: '22 años, Buenos Aires',
    text: 'Subí de Plata a Oro en 3 semanas. El capítulo de wave management me cambió la forma de jugar la línea. Simplemente brutal.',
    stars: 5
  }, {
    name: 'Santiago M.',
    info: '19 años, Bogotá',
    text: 'Siempre moría primero en las teamfights. Ahora entiendo dónde pararme y cuándo entrar. Increíble el cambio en mis partidas.',
    stars: 5
  }, {
    name: 'Diego L.',
    info: '25 años, CDMX',
    text: 'Pensé que era un libro más. Me equivoqué. Las tablas de decisión son oro puro para cualquiera que quiera tomarse el rol en serio.',
    stars: 5
  }, {
    name: 'Lucas P.',
    info: '21 años, Lima',
    text: 'Mi consistencia mejoró muchísimo. Antes ganaba 1 de cada 3, ahora mantengo un 60% de winrate sólido.',
    stars: 5
  }, {
    name: 'Andrés V.',
    info: '24 años, Santiago',
    text: 'Lo mejor es la sección de mentalidad. Dejé de tiltearme y empecé a pensar cada jugada. Recomendadísimo.',
    stars: 5
  }];
  return <section className="py-20 bg-[#0a0a0a] relative overflow-hidden" data-id="element-139">
      <div className="max-w-7xl mx-auto px-4" data-id="element-140">
        <div className="text-center mb-16" data-id="element-141">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6 uppercase tracking-tight" data-id="element-142">
            Resultados <span className="text-green-500" data-id="element-143">Reales</span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-144">
            Jugadores como vos que ya están subiendo de Elo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-145">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#111] p-8 rounded-2xl border border-gray-800 relative" data-id="element-146">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-gray-700 opacity-50" data-id="element-147" />

              <div className="flex gap-1 mb-4" data-id="element-148">
                {[...Array(t.stars)].map((_, i) => <Star key={i} className="w-5 h-5 text-amber-500 fill-amber-500" data-id="element-149" />)}
              </div>

              <p className="text-gray-300 mb-6 leading-relaxed italic" data-id="element-150">
                "{t.text}"
              </p>

              <div className="flex items-center gap-3" data-id="element-151">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-gray-700 to-gray-600 flex items-center justify-center text-white font-bold" data-id="element-152">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-153">
                  <h4 className="text-white font-bold text-sm" data-id="element-154">{t.name}</h4>
                  <p className="text-xs text-gray-500" data-id="element-155">{t.info}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}